<template>
  <path
    d="M15 13.0002V5.00024C15 3.34024 13.66 2.00024 12 2.00024C10.34 2.00024 9 3.34024 9 5.00024V13.0002C7.79 13.9102 7 15.3702 7 17.0002C7 19.7602 9.24 22.0002 12 22.0002C14.76 22.0002 17 19.7602 17 17.0002C17 15.3702 16.21 13.9102 15 13.0002ZM13 11.0002H11V5.00024C11 4.45024 11.45 4.00024 12 4.00024C12.55 4.00024 13 4.45024 13 5.00024H12.5C12.22 5.00024 12 5.22024 12 5.50024C12 5.78024 12.22 6.00024 12.5 6.00024H13V8.00024H12.5C12.22 8.00024 12 8.22024 12 8.50024C12 8.78024 12.22 9.00024 12.5 9.00024H13V11.0002Z"
  />
</template>
